export default {
  getWxSignature: process.env.BASE_URL + '/api/v1/weixin/get_signature',
  getWebUrl: process.env.BASE_URL + '/api/v1/weixin/get_web_url_bak',
  updateToken: process.env.BASE_URL + '/api/v1/weixin/update_token',
  // getWebUrl: process.env.BASE_URL + '/api/v1/weixin/get_web_url',
  getModel: process.env.BASE_URL + '/api/modules/common/index',
  sendSubInfo: process.env.BASE_URL + '/api/modules/common/subscribe',
  get payment() {
    return window.localStorage.getItem('test') === '1' ? (process.env.BASE_URL + '/api/v1/index/payment') : 'https://wxp.shenhudong.com/module_pay/index_newmini.php'
  },
  startUp: process.env.BASE_URL + '/api/modules/common/start_up',
  signUp: process.env.BASE_URL + '/api/modules/act_mger/submit',
  checkSignUp: process.env.BASE_URL + '/api/modules/common/is_sign',
  comment: process.env.BASE_URL + '/api/modules/common/comment',
  like: process.env.BASE_URL + '/api/modules/common/like',
  statistics: process.env.BASE_URL + '/api/modules/common/statistic',
  getOrgConfig: process.env.BASE_URL + '/api/modules/common/homepage_config/org',
  checkLimitCount: process.env.BASE_URL + '/api/modules/common/check_limit_count',
  checkLimitCountBak: process.env.BASE_URL + '/api/modules/common/check_limit_count_bak',
  checkLimitCity: process.env.BASE_URL + '/api/modules/common/limit_city',
  wannaCreate: process.env.BASE_URL + '/api/modules/common/wanna_create',
  stayTime: process.env.BASE_URL + '/api/modules/common/stay_time',
  addStaff: process.env.BASE_URL + '/api/v1/staff/binding',
  addBinding: process.env.BASE_URL + '/api/v1/usecard/binding',
  getNickNameAvatar: process.env.BASE_URL + '/api/modules/actmger/get_head',
  uploadClientFile: process.env.BASE_URL + '/api/v1/file/uploadClientFile',
}